import {FC, PropsWithChildren, useMemo} from "react";
import {useMarketLoading} from "@hooks/loadingHooks";
import {injectChild} from "@components/constructor";
import {useGameServerAuto, useLoginServerAuto} from "@hooks/selectors/game.selectors";
import {useItems} from "@hooks/selectors/user/item.selectors";
import {checkItemServers} from "../../../../../helpers/utils";

interface MarketProps {
    filter_items_by_login?: boolean;
    filter_items_by_game?: boolean;
}

interface MarketChildProps {
    market_loaded: boolean;
    market_loading: boolean;
    market_error: boolean;
    market_items_count: number;
    market_categories_count: number;
    filter_items_by_login?: boolean;
    filter_items_by_game?: boolean;
}

const Market: FC<PropsWithChildren<MarketProps>> = ({ children, filter_items_by_login, filter_items_by_game }) => {
    const { loaded, loading, error, data: market } = useMarketLoading();

    const itemIds = market?.items.map(x => x.itemId) || [];

    const items = useItems(itemIds);
    const login = useLoginServerAuto();
    const game = useGameServerAuto();

    const itemsCount = market?.items.filter(x => {
        const item = items.find(i => i.id === x.itemId);
        if (!item) return false;

        if (filter_items_by_login && login && !checkItemServers(item, login.id)) return false;
        if (filter_items_by_game && game && !checkItemServers(item, game.id)) return false;

        return true;
    }).length || 0;
    const categoriesCount = market?.categories.length || 0;
    const itemsLoading = items.some(item => item.loading);

    const data = useMemo<MarketChildProps>(() => ({
        market_loaded: loaded,
        market_loading: loading || itemsLoading,
        market_error: Boolean(error),
        market_items_count: itemsCount,
        market_categories_count: categoriesCount,
        filter_items_by_login,
        filter_items_by_game
    }), [loaded, loading, itemsLoading, error, itemsCount, categoriesCount, filter_items_by_login, filter_items_by_game]);

    return injectChild(data, children);
}

export default Market;